"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonsWrapper = exports.inputClearButton = exports.inputButton = exports.input = void 0;
const tv_1 = require("../utils/tv");
const tw_1 = require("../utils/tw");
const Status = {
  default: 'default',
  success: 'success',
  error: 'error'
};
const Size = {
  small: 'small',
  medium: 'medium'
};
exports.input = (0, tv_1.tv)({
  base: `
    rounded-sm border-md border-secondary bg-primary text-primary
    placeholder:text-secondary
    focus:outline-none
  `,
  variants: {
    status: {
      [Status.default]: `
        hover:border-neutral-hover
        focus:border-keyboard-focus
        disabled:border-neutral-disabled disabled:text-disabled
        [&:user-invalid]:border-critical [&:user-invalid]:bg-critical-soft
      `,
      [Status.success]: `border-positive bg-positive-soft`,
      [Status.error]: `border-critical bg-critical-soft`
    },
    size: {
      small: `min-h-[42px] px-md text-sm leading-sm`,
      medium: `min-h-[48px] px-md text-md leading-md`
    },
    withSparkLabel: {
      true: `
        peer
        placeholder:opacity-0
        focus:placeholder:opacity-100
      `,
      false: ``
    },
    withClearButton: {
      true: `peer`,
      false: ``
    },
    withVisibilityButton: {
      true: `peer`,
      false: ``
    }
  },
  compoundVariants: [{
    status: [Status.success, Status.error],
    class: ``
  }, {
    size: Size.medium,
    withSparkLabel: true,
    class: `pt-sm`
  }, {
    size: Size.small,
    withSparkLabel: true,
    class: `pt-sm`
  }, {
    withClearButton: true,
    withVisibilityButton: true,
    class: `pr-14`
  }, {
    withClearButton: true,
    withVisibilityButton: false,
    class: `pr-2xl`
  }, {
    withClearButton: false,
    withVisibilityButton: true,
    class: `pr-2xl`
  }],
  defaultVariants: {
    size: 'medium',
    status: 'default'
  }
});
exports.inputButton = (0, tw_1.tw)(`
  flex size-xl items-center justify-center rounded-full text-primary
  outline-none
  hover:bg-primary
  focus:border-sm focus:border-keyboard-focus
  focus-visible:border-sm focus-visible:border-keyboard-focus
`);
exports.inputClearButton = (0, tv_1.tv)({
  base: exports.inputButton,
  variants: {
    hideClearButton: {
      true: `hidden`,
      false: ``
    }
  }
});
exports.buttonsWrapper = (0, tv_1.tv)({
  base: `
    absolute right-sm top-md z-10 flex h-fit
    peer-[[size=small]]:top-[0.6rem]
  `
});
